import axios from 'axios';

export default function getReportTypes(config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const url = config.getReportTypes;
  return dispatch => dispatch({
    type: 'REPORT_TYPES_FETCH',
    payload: axios({ method: 'get', url, headers })
  });
}


// WEBPACK FOOTER //
// ./src/actions/getReportTypes.js